import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { panelMessages } from '../messages/panelMessages';
import { formatTime } from '../timeline/timelineGeometry';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The lines of the song with their timing (design d1). A click jumps there and selects the line. A
 * line with no time says "no time" (the editor answer has no score, so the design's "check" of a
 * weak line shows on the song page only).
 */
const LyricLinesComponent: React.FC = () => {
  const intl = useIntl();
  const { data, selection, select, transport } = useMusicVideoEditor();
  const selectedIndex = selection?.kind === 'lyric' ? selection.index : null;
  return (
    <>
      <div className={styles.sectionHead}>
        <b>{intl.formatMessage(panelMessages.linesHeading)}</b>
        <small>{intl.formatMessage(panelMessages.linesHint)}</small>
      </div>
      <div className={styles.column}>
        {data.lyrics.lines.map((line) => (
          <button
            key={line.index}
            type="button"
            className={clsx(styles.lyricLine, line.index === selectedIndex && styles.lyricLineOn)}
            aria-pressed={line.index === selectedIndex}
            onClick={() => {
              select({ kind: 'lyric', index: line.index });
              if (line.startMs !== null) {
                transport.seek(line.startMs / 1000);
              }
            }}
          >
            <span className={styles.lyricTime}>
              {line.startMs === null ? '—' : formatTime(line.startMs / 1000, true)}
            </span>
            <span>{line.text}</span>
            {line.startMs === null ? (
              <span className={styles.lyricFix}>{intl.formatMessage(panelMessages.lineNoTime)}</span>
            ) : (
              <span className={styles.lyricOk}>{intl.formatMessage(panelMessages.lineSynced)}</span>
            )}
          </button>
        ))}
      </div>
    </>
  );
};

export const LyricLines = TypedMemo(LyricLinesComponent);
